import React, { ChangeEvent } from 'react';
import styled from 'styled-components';

const FileUplodaWrapper = styled.div`
  margin-top: 12px;
  display: flex;
  align-items: center;
  width: 60%;
  justify-content: space-between;
  @media ${props => props.theme.device.laptop} {
    width: 100%;
  }
`;
const FileLabel = styled.label<{ labelWidth?: number }>`
  font-size: 20px;
  min-width: 100px;
  width: ${props => `${props.labelWidth}%`};
  color: #666;
  @media ${props => props.theme.device.laptop} {
    font-size: 16px;
  }
  @media ${props => props.theme.device.mobile} {
    font-size: 12px;
  }
`;
const Box = styled.div<{ inputWidth: number }>`
  display: flex;
  width: ${props => `${props.inputWidth}%`};
  align-items: center;
`;
const InputButtonWrapper = styled.div<{ inputWidth?: number }>`
  display: flex;
  border: solid 1px #666;
  border-radius: 4px;
  /* padding: 4px; */
  height: 25px;
  width: ${props => `${props.inputWidth}%`};

  /* justify-content: space-between; */
`;

const InputLabel = styled.label`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 60px;

  &:hover {
    cursor: pointer;
  }
  > p {
    font-size: 12px;
    @media ${props => props.theme.device.laptop} {
      font-size: 10px;
    }
  }
`;

const FileName = styled.div`
  margin-left: 12px;
  display: flex;
  align-items: center;
  font-size: 12px;
  color: red;
  @media ${props => props.theme.device.laptop} {
    font-size: 8px;
  }
`;

interface FileProps {
  //파일 업로드 타입 x
  // handleChangeFile: (event: React.ChangeEvent<HTMLInputElement>) => void;
  inputWidth: number;
  labelWidth: number;
  setUploadFile: (file: File | null) => void;
  uploadFile: File | null;
  /** optional id for the input element (useful for multiple instances) */
  id?: string;
  /** label text to show next to input */
  label?: string;
  /** allowed accept string (e.g. ".pdf,.jpg") */
  accept?: string;
}

function FielUpload(props: FileProps) {
  const {
    inputWidth,
    labelWidth,
    setUploadFile,
    uploadFile,
    id = 'input-file',
    label = '첨부파일',
    accept = '.zip,.rar,.7zip,.pdf,.jpg,.jpeg,.png'
  } = props;

  const allowedExts = accept.split(',').map(s => s.replace('.', '').trim().toLowerCase());

  const handleChangeFile = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const fileExtension = (file.name.split('.').pop() || '').toLowerCase();
    if (!allowedExts.includes(fileExtension)) {
      alert(`${accept} 형식의 파일만 가능합니다`);
      return;
    }

    //파일사이즈
    const fileSize = file.size;
    //최대 파일사이즈
    const maxSize = 20000000;
    if (fileSize > maxSize) {
      alert(
        `20MB 이내의 파일만 첨부 가능합니다.\n현재 파일크기_${(file.size / (1000 * 1000)).toFixed(1)}MB`
      );
      setUploadFile(null);
    } else {
      setUploadFile(file);
    }
  };

  return (
    <FileUplodaWrapper>
      <FileLabel labelWidth={labelWidth}>{label}</FileLabel>
      <Box inputWidth={inputWidth}>
        <InputButtonWrapper>
          <InputLabel htmlFor={id}>
            <p>첨부하기</p>
          </InputLabel>
        </InputButtonWrapper>
        <FileName>
          {!!uploadFile && uploadFile !== null ? (
            <p>{uploadFile.name}</p>
          ) : (
            <p>{accept} 형식만 가능합니다. 첨부파일의 크기를 20MB 이내로 첨부해주세요</p>
          )}
        </FileName>
      </Box>
      <input hidden id={id} name={id} type="file" accept={accept} onChange={handleChangeFile} />
    </FileUplodaWrapper>
  );
}

export default FielUpload;
